import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import styles from './LightNav.module.css';
import { useTranslation } from 'react-i18next';
const LightNav = () => {
  const navigate = useNavigate(); 
  const { t } = useTranslation();
		return (
		<>
		<nav className={styles["compact-navbar"]}>
		<div style={{"cursor": "pointer"}} onClick={() => navigate("/home")} className={styles.logo}>{t('admin.ratioAdmin')}</div>
		  <ul className={`${styles["navbar-links"]}`}>
			<li><Link to="/admin/how-it-works">{t('admin.howItWorks')}</Link></li>
			<li><Link to="/admin/community-rules">{t('admin.rules')}</Link></li>
			<li><Link to="/admin/new-features">{t('admin.features')}</Link></li>
			<li><Link to="/admin/siteinfo">{t('admin.siteInfo')}</Link></li>
			<li><Link to="/admin/adminroles">{t('admin.adminRoles')}</Link></li>
			<li><Link to="/admin/adminconfigwizard">{t('admin.adminConfigWizard')}</Link></li>
			<li><Link to="/admin/adminrssfeeds">{t('admin.adminRssFeeds')}</Link></li>
		  </ul>
		</nav>
		</>
	  );
};

export default LightNav;
